/* template */
<template><div class="navigation-bar"><div class="tab-wrap tab-wrap_tab"><mpx-image :class="(pageStatus === EnumMallPageStatus.SaveMoneySet || pageStatus === null ? 'active' : 'normal')" :src="(pageStatus === EnumMallPageStatus.SaveMoneySet || pageStatus === null ? titleImageList[0].active : titleImageList[0].normal)" @tap="swtichPage1" class="title-image"/><mpx-image :class="(pageStatus === EnumMallPageStatus.SaveMoneyCard ? 'active' : 'normal')" :src="(pageStatus === EnumMallPageStatus.SaveMoneyCard ? titleImageList[1].active : titleImageList[1].normal)" @tap="swtichPage2" class="title-image"/></div><div class="right-contents"><btn-city-select :city-name="(cityName)" :city-id="(cityId)" :pageStatus="(pageStatus)" compact/></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mbaa3b8b4"}'>
.navigation-bar
  position relative
  width 100%
  display flex
  // padding 20rpx 110rpx 20rpx 190rpx
  padding 10rpx 0
  height 82rpx
  align-items center

.title-image-list-wrap
  width 390rpx
  height 42rpx
  padding-right 50rpx

.right-contents
  position absolute
  right 46rpx
  top auto
  margin-top 6rpx

.tab-wrap
  padding 0 110rpx 0 190rpx
  display: flex;
  justify-content: space-around;

.title-image
  width 138rpx
  height 42rpx
  margin-right 38rpx
  position relative
  &:last-child
    margin-right: 0;
  &.active:after
    content ''
    display block
    width 43rpx
    height 6rpx
    background #F9D861
    box-shadow 0px 0px 4px 0px rgba(240,73,63,1)
    border-radius 3px
    position absolute
    bottom -19rpx
    left 50%
    margin-left -21rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { GlobalEnv } from '../../lib/webx'
import { EnumLang, EnumMallPageStatus } from '../../lib/webx/defines'

createComponent({
  name: 'NavigationBar',
  properties: {
    cityName: String,
    cityId: [ String, Number ],
    pageStatus: Number,
    existCard: Boolean,
  },
  data: {
    EnumMallPageStatus,
    atDidao: GlobalEnv.atDidao,
    isZHCN: GlobalEnv.lang === EnumLang['zh-CN'],
    titleImageList: [ // 标题image
      {
        normal: 'https://dpubstatic.udache.com/static/dpubimg/i_1UG0FV4qQXxMj799beF.png',
        active: 'https://dpubstatic.udache.com/static/dpubimg/KQTMzO2TBzM3PRndxnQ8x.png',
      },
      {
        normal: 'https://dpubstatic.udache.com/static/dpubimg/83-z1u-ypT0tJiGiwcJOC.png',
        active: 'https://dpubstatic.udache.com/static/dpubimg/8ZiLztrNiviOqdKkwqlBB.png',
      },
    ],
  },
  computed: {
  },
  methods: {
    swtichPage1() {
      this.triggerEvent('change-page', EnumMallPageStatus.SaveMoneySet)
    },
    swtichPage2() {
      this.triggerEvent('change-page', EnumMallPageStatus.SaveMoneyCard)
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "tab_barbaa3b8b4",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'btn-city-select':getComponent(require("./navigation_bar/components/btn_city_select.mpx?component=true&componentId=btn_city_select4c940890")),'mpx-image':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
